import { Loader } from '@googlemaps/js-api-loader';

export default async function streetPano() {
  if (!document.querySelector('#street-view-picker')?.dataset) {
    return;
  }

  const startingPosition = {
    lat: parseFloat(
      document.querySelector('#street-view-picker').dataset.lat,
    ),
    lng: parseFloat(
      document.querySelector('#street-view-picker').dataset.lng,
    ),
  };

  const startingPov = {
    heading: parseInt(
      document.querySelector('#street-view-picker').dataset.heading,
      10,
    ),
    pitch: parseInt(
      document.querySelector('#street-view-picker').dataset.pitch,
      10,
    ),
  };

  const loader = new Loader({
    apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    version: 'weekly',
  });

  await loader.load();

  const panorama = new google.maps.StreetViewPanorama(
    document.getElementById('pano'),
    {
      position: startingPosition,
      pov: startingPov,
      visible: true,
      addressControl: false,
      panControl: false,
      zoomControl: false,
      fullscreenControl: false,
      enableCloseButton: false,
      scrollwheel: false,
    },
  );

  panorama.addListener('status_changed', () => {
    if (panorama.getStatus() === google.maps.StreetViewStatus.ZERO_RESULTS) {
      Livewire.emit('streetViewUnavailable');
    }
  });

  panorama.addListener('pano_changed', _.debounce(() => {
    Livewire.emit('panoChanged', panorama.getPano());
  }, 500));

  panorama.addListener('position_changed', _.debounce(() => {
    Livewire.emit('positionChanged', panorama.getPosition());
  }, 500));

  panorama.addListener('pov_changed', _.debounce(() => {
    Livewire.emit('povChanged', panorama.getPov());
  }, 500));

  Livewire.on('resetView', () => {
    panorama.setPosition(startingPosition);
    panorama.setPov(startingPov);
  });
}
